import { Box, LoadingOverlay } from '@mantine/core';

export function AdminPendingComponent() {
  return (
    <Box pos="relative" mih={400}>
      <LoadingOverlay visible/>
    </Box>
  );
}
